






























































import delay from "../../modules/delay";
import {Component, Inject, Prop, Vue} from "vue-property-decorator";
import {JLocation, Terminal} from "../../modules/models";
import Api from "./Api";
import * as VueGoogleMaps from "vue2-google-maps";
import {GoogleMapsApiKey} from "../../modules/constants";
import UserRequired from "../UserRequired";
import {PluginFunction} from "vue";

const TheftAlarmState_Disabled = 0;
const TheftAlarmState_PendingActivation = 1;       // Monitoring was activated serverside, waiting for confirmation (first connection signal) from terminal
const TheftAlarmState_MonitoringActive = 2;       // Monitoring for periodic connection signals
const TheftAlarmState_MonitoringDisconnected = 3;  // Monitoring is active but terminal is currently disconnected legally
const TheftAlarmState_TriggeredTerminal = 4;       // Alarm was triggered on terminal and is active.
const TheftAlarmState_TriggeredServer = 5;         // Alarm was triggered by missing connectionsignal to server and is active.   v

Vue.use(VueGoogleMaps as PluginFunction<any>, {
    load: {
        key: GoogleMapsApiKey
    }
});

@Component
export default class TerminalDisconnectalarm extends UserRequired {
    @Inject()
    api!: Api;
    @Prop()
    guid!: string;

    terminal: Terminal | null = null;
    alarmstatus: number = -1;
    geoloc: JLocation | null = null;

    async loadTerminal() {
        const info = await this.api.fetchTerminal(this.guid);
        this.terminal = info.terminal;
    }
    async loadAlarmstatus() {
        this.alarmstatus = await this.api.terminalAlarmStatus(this.guid);
    }
    async loadGeoloc() {
        this.geoloc = await this.api.terminalGeolocation(this.guid);
    }

    get mapLocation() {
        return this.geoloc != null ? {lat: this.geoloc.latitude, lng: this.geoloc.longitude} : null;
    }

    refreshingInfo = false;
    async refreshInfo() {
        this.refreshingInfo = true;
        try {
            await this.loadAlarmstatus();
            await this.loadGeoloc();
        } catch(err) {
            this.emitError(err);
        } finally {
            this.refreshingInfo = false;
        }
    }

    alarmstatusTxt(): string {
        switch(this.alarmstatus) {
            case TheftAlarmState_Disabled: return "Alarm deaktivert";
            case TheftAlarmState_PendingActivation: return "Venter på aktivering";
            case TheftAlarmState_MonitoringActive: return "Alarm ok, strøm tilkoblet";
            case TheftAlarmState_MonitoringDisconnected: return "Alarm ok, godkjent frakoblet";
            case TheftAlarmState_TriggeredTerminal: return "Uautorisert frakobling av terminal";
            case TheftAlarmState_TriggeredServer: return "Manglende signal fra terminal";
            default: return "Ukjent";
        }
    }
    alarmstatusType(): string {
        switch(this.alarmstatus) {
            case TheftAlarmState_Disabled: return "info";
            case TheftAlarmState_PendingActivation: return "info";
            case TheftAlarmState_MonitoringActive: return "success";
            case TheftAlarmState_MonitoringDisconnected: return "success";
            case TheftAlarmState_TriggeredTerminal: return "error";
            case TheftAlarmState_TriggeredServer: return "warning";
            default: return "info";
        }
    }
    isChangingstate = false;
    async activateAlarm() {
        try {
            this.isChangingstate = true;
            await this.api.setDisconnectAlarmFromServer(this.guid, TheftAlarmState_MonitoringActive);
            await delay(2000);
            await this.refreshInfo();
            if(this.alarmstatus <= 0) {
                this.showRefreshReminderSnack = true;
            }
        } catch(err) {
            this.emitError(err);
        } finally {
            this.isChangingstate = false;
        }
    }
    async deactivateAlarm() {
        try {
            this.isChangingstate = true;
            await this.api.setDisconnectAlarmFromServer(this.guid, TheftAlarmState_Disabled);
            await delay(2000);
            await this.refreshInfo();
            if(this.alarmstatus != TheftAlarmState_Disabled) {
                this.showRefreshReminderSnack = true;
            }
        } catch(err) {
            this.emitError(err);
        } finally {
            this.isChangingstate = false;
        }
    }
    showRefreshReminderSnack = false;

    created() {
        this.loadTerminal();
        this.loadAlarmstatus();
        this.loadGeoloc();
    }
}
